import {TrainingObjectiveDao} from '../../dao';
import {TrainingObjectiveModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_OBJECTIVE_BY_ID';

export async function updateTrainingObjective(
    userData: Record<string, string>,
    trainingObjectiveId: number,
    update: Record<string, any>
) {
    try {
        const result = await TrainingObjectiveDao.updateTrainingObjective(userData.userToken, trainingObjectiveId, update);

        const resultParsed = TrainingObjectiveModel.parseTrainingObjective(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
